/**
 * Created by perl on 23/08/16.
 */

angular.module('taric.duty.exchangerates', ['taric.model.er', 'taric.model.monetaryunits', 'common.filter.decimalNumber', 'common.helper', 'common.directive.monetaryUnit', 'common.filter.decimalNumberExchangeRateResult'])
    .controller('ExchangeRatesController', function (CONSTANTS, ExchangeRatesModel, MonetaryUnitsModel, $rootScope, $scope, $state, $stateParams, $translatePartialLoader, $uibModal, $filter, CommonHelper, $translate, monetaryUnits, $timeout, $location) {
        var exchangeRatesCtrl = this;
        exchangeRatesCtrl.searchExchangeRatesResult = null;
        exchangeRatesCtrl.calculateExchangeRateResult = null;
        exchangeRatesCtrl.reportDate = null;
        
        // Check whether the search form is valid or not
        exchangeRatesCtrl.validateSearchForm = function() {
            exchangeRatesCtrl.handleSearchError();
            return exchangeRatesCtrl.validateMonetaryUnit() && exchangeRatesCtrl.validateDates();
        };

        exchangeRatesCtrl.validateMonetaryUnit = function(){
            exchangeRatesCtrl.searchErrorCode = exchangeRatesCtrl.controlMonetaryUnit.validate();
            return exchangeRatesCtrl.searchErrorCode === null;
        };

        exchangeRatesCtrl.validateDates = function () {
            if (!CONSTANTS.dateRestrictionEnabled) {
                exchangeRatesCtrl.searchErrorCode = CommonHelper.validateSimulationDate(exchangeRatesCtrl.searchCriteria.fromDate);
                if (exchangeRatesCtrl.searchErrorCode) {
                    exchangeRatesCtrl.searchErrorParams = {param0: CONSTANTS.pastDate};
                    return false;
                }
                exchangeRatesCtrl.searchErrorCode = CommonHelper.validateSimulationDate(exchangeRatesCtrl.searchCriteria.toDate);
                if (exchangeRatesCtrl.searchErrorCode) {
                    exchangeRatesCtrl.searchErrorParams = {param0: CONSTANTS.pastDate};
                    return false;
                }
            }
            if (typeof exchangeRatesCtrl.searchCriteria.fromDate !== 'undefined' &&
                exchangeRatesCtrl.searchCriteria.fromDate !== null &&
                typeof exchangeRatesCtrl.searchCriteria.toDate !== 'undefined' &&
                exchangeRatesCtrl.searchCriteria.toDate !== null) {
                if (CommonHelper.compareDatesWithoutTime(exchangeRatesCtrl.searchCriteria.toDate, exchangeRatesCtrl.searchCriteria.fromDate) < 0) {
                    exchangeRatesCtrl.searchErrorCode = "i8n.qry.er.invalidPeriod";
                    return false;
                }
            }
            return exchangeRatesCtrl.searchErrorCode === null;
        };

        //Check whether the external parameters are valid or not
        exchangeRatesCtrl.validateExternalParameters = function(){
            exchangeRatesCtrl.handleSearchError();
            return exchangeRatesCtrl.validateDates();
        };

        // Load data for a given page
        exchangeRatesCtrl.loadDataFromServer = function(pageNumber){
            if (!exchangeRatesCtrl.validateSearchForm()){
                return;
            }

            exchangeRatesCtrl.loadDataFromServerWithoutValidation(pageNumber);
        };

        //Load data for a given page without validation
        exchangeRatesCtrl.loadDataFromServerWithoutValidation = function (pageNumber) {
            // Reset search result before searching
            exchangeRatesCtrl.resetSearchResult();
            exchangeRatesCtrl.searching = true;
            ExchangeRatesModel.queryMonetaryExchangePeriodWithRateDirection(pageNumber).then(function(searchExchangeRatesResult) {
                exchangeRatesCtrl.searchExchangeRatesResult = searchExchangeRatesResult;
                exchangeRatesCtrl.searching = false;
                exchangeRatesCtrl.updateBrowserURL();

                if (typeof exchangeRatesCtrl.searchCriteria.fromDate !== 'undefined' &&
                    exchangeRatesCtrl.searchCriteria.fromDate !== null &&
                    exchangeRatesCtrl.searchCriteria.fromDate !== '') {
                    exchangeRatesCtrl.searchExchangeRatesResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(exchangeRatesCtrl.searchCriteria.fromDate);
                    if (exchangeRatesCtrl.searchExchangeRatesResult.infoCode &&
                        "i8n.common.pastDate" === exchangeRatesCtrl.searchExchangeRatesResult.infoCode) {
                        exchangeRatesCtrl.searchExchangeRatesResult.infoParams = CONSTANTS.pastDate;
                    }
                }
                if (typeof exchangeRatesCtrl.searchCriteria.toDate !== 'undefined' &&
                    exchangeRatesCtrl.searchCriteria.toDate !== null &&
                    exchangeRatesCtrl.searchCriteria.toDate !== '') {
                    exchangeRatesCtrl.searchExchangeRatesResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(exchangeRatesCtrl.searchCriteria.toDate);
                    if (exchangeRatesCtrl.searchExchangeRatesResult.infoCode &&
                        "i8n.common.pastDate" === exchangeRatesCtrl.searchExchangeRatesResult.infoCode) {
                        exchangeRatesCtrl.searchExchangeRatesResult.infoParams = CONSTANTS.pastDate;
                    }
                }

            }, function(error){
                exchangeRatesCtrl.searchErrorCode = error.data.code;
                exchangeRatesCtrl.searchErrorParams = error.data.params;
                exchangeRatesCtrl.searching = false;
            });
        };

        exchangeRatesCtrl.resetSearchResult = function() {
            exchangeRatesCtrl.searchExchangeRatesResult = null;
        };

        exchangeRatesCtrl.search = function () {
            // Load data for the first page
            exchangeRatesCtrl.loadDataFromServer(1);
        };

        // Handle page change for the exchange rates search result table
        exchangeRatesCtrl.searchExchangeRatesResultPageChanged = function (pageNumber) {
            exchangeRatesCtrl.loadDataFromServer(pageNumber);
        };

        exchangeRatesCtrl.init = function () {
            // Validated data used for search exchange rates input
            exchangeRatesCtrl.searchInputData = ExchangeRatesModel.getSearchExchangeRatesInput();
            // Backing data model for view
            exchangeRatesCtrl.model = ExchangeRatesModel;
            exchangeRatesCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            exchangeRatesCtrl.searchCriteria = ExchangeRatesModel.getSearchCriteria();
            exchangeRatesCtrl.calculateCriteria = ExchangeRatesModel.getCalculateCriteria();
            exchangeRatesCtrl.installationCountry = CONSTANTS.installationCountry;
            exchangeRatesCtrl.installationCurrency = CONSTANTS.installationCurrency;
            exchangeRatesCtrl.calculateExchangeRateResult = ExchangeRatesModel.getCalculateExchangeRateResult();
            exchangeRatesCtrl.dateFormat = CONSTANTS.dateFormat;
            exchangeRatesCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
            exchangeRatesCtrl.controlMonetaryUnit = {};
            exchangeRatesCtrl.monetaryUnits = monetaryUnits;
            exchangeRatesCtrl.model.customsValueMonetaryUnits = monetaryUnits;
            exchangeRatesCtrl.searchTabIndex = 0;
            exchangeRatesCtrl.calculateTabIndex = 1;
            exchangeRatesCtrl.activeTabIndex = exchangeRatesCtrl.searchTabIndex;
            exchangeRatesCtrl.menu = CONSTANTS.menu;

            if (exchangeRatesCtrl.isExternalLink() && exchangeRatesCtrl.validateExternalParameters()) {
                // Get valid monetaryUnit
                exchangeRatesCtrl.searchCriteria.monetaryUnit = CommonHelper.getValidSelectedItem(
                    exchangeRatesCtrl.monetaryUnits.items,
                    exchangeRatesCtrl.searchCriteria.monetaryUnit,
                    null);

                // Only auto-search to support bookmark when there are required parameters, and all parameters are valid.
                exchangeRatesCtrl.loadDataFromServerWithoutValidation(1);
            }
        };

        exchangeRatesCtrl.isExternalLink = function(){
            return ($stateParams.mu || $stateParams.ds || $stateParams.de);
        };

        exchangeRatesCtrl.resetSearchError = function(){
            exchangeRatesCtrl.handleSearchError(null);
        };

        exchangeRatesCtrl.resetCalculateError = function(){
            exchangeRatesCtrl.handleCalculateError(null);
        };

        exchangeRatesCtrl.handleSearchError = function(error) {
            if(!error) {
                exchangeRatesCtrl.searchErrorCode = null;
                exchangeRatesCtrl.searchErrorParams = null;
                exchangeRatesCtrl.searchErrorType = null;
            } else {
                exchangeRatesCtrl.searchErrorCode = error.errorCode;
                exchangeRatesCtrl.searchErrorParams = error.errorParams;
                exchangeRatesCtrl.searchErrorType = error.errorType;
            }
        };

        exchangeRatesCtrl.handleCalculateError = function(error) {
            if(!error) {
                exchangeRatesCtrl.calculateErrorCode = null;
                exchangeRatesCtrl.calculateErrorParams = null;
                exchangeRatesCtrl.calculateErrorType = null;
            } else {
                exchangeRatesCtrl.calculateErrorCode = error.errorCode;
                exchangeRatesCtrl.calculateErrorParams = error.errorParams;
                exchangeRatesCtrl.calculateErrorType = error.errorType;
            }
        };

        exchangeRatesCtrl.onMonetaryUnitChange = function(monetaryUnit){
            exchangeRatesCtrl.searchCriteria.monetaryUnit = monetaryUnit;
        };

        exchangeRatesCtrl.hasNationalMonetaryUnits = function(){
            var nationalMonetaryUnits = exchangeRatesCtrl.monetaryUnits.items.filter(function(monetaryUnit){
                return monetaryUnit.national === true;
            });
            return nationalMonetaryUnits.length > 0;
        };

        exchangeRatesCtrl.openDatePickerFromDate = function ($event) {
            exchangeRatesCtrl.isDatePickerOpenFromDate = true;
        };

        exchangeRatesCtrl.openDatePickerToDate = function ($event) {
            exchangeRatesCtrl.isDatePickerOpenToDate = true;
        };

        exchangeRatesCtrl.openDatePickerDate = function ($event) {
            exchangeRatesCtrl.isDatePickerOpenDate = true;
        };

        exchangeRatesCtrl.reloadSearchMonetaryUnits = function () {
            MonetaryUnitsModel.customsValueMonetaryUnits(exchangeRatesCtrl.searchCriteria.fromDate).then(function (monetaryUnits) {
                exchangeRatesCtrl.monetaryUnits = monetaryUnits;
            });
        };

        exchangeRatesCtrl.reloadCalculateMonetaryUnits = function () {
            MonetaryUnitsModel.customsValueMonetaryUnits(exchangeRatesCtrl.calculateCriteria.exchangeDate).then(function (monetaryUnits) {
                exchangeRatesCtrl.monetaryUnits = monetaryUnits;
            });
        };

        exchangeRatesCtrl.onFromDateChange = function (dateString) {
            exchangeRatesCtrl.resetSearchError();
            exchangeRatesCtrl.searchCriteria.fromDate = CommonHelper.formatDate(exchangeRatesCtrl.searchCriteria.fromDate, dateString);
            if (exchangeRatesCtrl.searchCriteria.fromDate){
                exchangeRatesCtrl.reloadSearchMonetaryUnits();
            }
        };

        exchangeRatesCtrl.onToDateChange = function (dateString) {
            exchangeRatesCtrl.resetSearchError();
            exchangeRatesCtrl.searchCriteria.toDate = CommonHelper.formatDate(exchangeRatesCtrl.searchCriteria.toDate, dateString);
            if (exchangeRatesCtrl.searchCriteria.fromDate){
                exchangeRatesCtrl.reloadSearchMonetaryUnits();
            }
        };

        exchangeRatesCtrl.onExchangeDateChange = function (dateString) {
            exchangeRatesCtrl.resetCalculateError();
            exchangeRatesCtrl.calculateCriteria.exchangeDate = CommonHelper.formatDate(exchangeRatesCtrl.calculateCriteria.exchangeDate, dateString);
            if (exchangeRatesCtrl.calculateCriteria.exchangeDate){
                exchangeRatesCtrl.reloadCalculateMonetaryUnits();
            }
        };

        exchangeRatesCtrl.validateAmount = function () {
            exchangeRatesCtrl.calculateExchangeRateResult.amount = '0';
            exchangeRatesCtrl.calculateExchangeRateResult.amountEUR = '0';

            if (!exchangeRatesCtrl.calculateCriteria.amount) {
                exchangeRatesCtrl.calculateErrorCode = 'i8n.qry.er.faultcode.106';
                return false;
            }

            if (!CommonHelper.isDecimalNumber(exchangeRatesCtrl.calculateCriteria.amount)) {
                exchangeRatesCtrl.calculateErrorCode = 'i8n.jsfconv.decnum.notnum';
                return false;
            }

            var amount = CommonHelper.getDecimalNumber(exchangeRatesCtrl.calculateCriteria.amount);
            if (amount < 0) {
                exchangeRatesCtrl.calculateErrorCode = 'i8n.jsfconv.decnum.notnegative';
                return false;
            }

            exchangeRatesCtrl.calculateCriteria.amount = CommonHelper.formatDecimalNumber(amount,
                CommonHelper.getNumberFraction(amount), '', CONSTANTS.decimalSeparator);

            return true;
        };

        exchangeRatesCtrl.validateFromCurrency = function () {
            var valid = true;
            if (!exchangeRatesCtrl.calculateCriteria.fromCurrency) {
                exchangeRatesCtrl.calculateCriteria.amount = '0';
                exchangeRatesCtrl.calculateExchangeRateResult.amount = '0';
                exchangeRatesCtrl.calculateExchangeRateResult.amountEUR = '0';
                exchangeRatesCtrl.calculateErrorCode = 'i18n.common.validation.monetary.code.missing';
                valid = false;
            }
            return valid;
        };

        exchangeRatesCtrl.validateExchangeDate = function () {
            if (!CONSTANTS.dateRestrictionEnabled) {
                exchangeRatesCtrl.calculateErrorCode = CommonHelper.validateSimulationDate(exchangeRatesCtrl.calculateCriteria.exchangeDate);
                if (exchangeRatesCtrl.calculateErrorCode){
                    exchangeRatesCtrl.calculateErrorParams = {param0: CONSTANTS.pastDate};
                }
            }
            return exchangeRatesCtrl.calculateErrorCode === null;
        };

        // Check whether the calculate form is valid or not
        exchangeRatesCtrl.validateCalculateForm = function() {
            exchangeRatesCtrl.resetCalculateError();
            return exchangeRatesCtrl.validateAmount() &&
                exchangeRatesCtrl.validateFromCurrency() &&
                exchangeRatesCtrl.validateExchangeDate();
        };

        // Calculate exchange rate
        exchangeRatesCtrl.calculate = function() {
            if (!exchangeRatesCtrl.validateCalculateForm()){
                return;
            }
            exchangeRatesCtrl.calculating = true;
            ExchangeRatesModel.resetCalculateResult();
            exchangeRatesCtrl.calculateExchangeRateResult = ExchangeRatesModel.getCalculateExchangeRateResult();
            ExchangeRatesModel.calculateExchangeRate().then(function(calculateExchangeRateResult) {
                exchangeRatesCtrl.calculateExchangeRateResult = calculateExchangeRateResult;
                exchangeRatesCtrl.calculateExchangeRateResult.amount =
                    accounting.formatNumber(exchangeRatesCtrl.calculateExchangeRateResult.amount, CONSTANTS.numberFractionExchangeRateResult, CONSTANTS.thousandsSeparator, CONSTANTS.decimalSeparator);
                exchangeRatesCtrl.calculateExchangeRateResult.amountEUR =
                    accounting.formatNumber(exchangeRatesCtrl.calculateExchangeRateResult.amountEUR, CONSTANTS.numberFractionExchangeRateResult, CONSTANTS.thousandsSeparator, CONSTANTS.decimalSeparator);

                exchangeRatesCtrl.calculating = false;

                exchangeRatesCtrl.calculateExchangeRateResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(exchangeRatesCtrl.calculateCriteria.exchangeDate);
                if (exchangeRatesCtrl.calculateExchangeRateResult.infoCode &&
                    "i8n.common.pastDate" === exchangeRatesCtrl.calculateExchangeRateResult.infoCode) {
                    exchangeRatesCtrl.calculateExchangeRateResult.infoParams = CONSTANTS.pastDate;
                    exchangeRatesCtrl.calculateCriteria.amount = '0';
                    exchangeRatesCtrl.calculateExchangeRateResult.amount = '0';
                    exchangeRatesCtrl.calculateExchangeRateResult.amountEUR = '0';
                }
                if (exchangeRatesCtrl.calculateExchangeRateResult.infoCode &&
                    "i8n.common.futureDate" === exchangeRatesCtrl.calculateExchangeRateResult.infoCode) {
                    exchangeRatesCtrl.calculateCriteria.amount = '0';
                    exchangeRatesCtrl.calculateExchangeRateResult.amount = '0';
                    exchangeRatesCtrl.calculateExchangeRateResult.amountEUR = '0';
                }

            }, function(error){
                exchangeRatesCtrl.calculateErrorCode = error.data.code;
                exchangeRatesCtrl.calculateErrorParams = error.data.params;
                exchangeRatesCtrl.calculating = false;
            });
        };

        // Calculate exchange rate for select row in GUI
        exchangeRatesCtrl.calculateRow = function(monetaryUnit, fromDate) {
            exchangeRatesCtrl.calculating = true;
            exchangeRatesCtrl.calculateExchangeRateResult = null;
            ExchangeRatesModel.resetCalculateResult();
            exchangeRatesCtrl.calculateCriteria.amount = 1;
            exchangeRatesCtrl.calculateCriteria.fromCurrency = monetaryUnit;
            var newFromDate = new Date(fromDate);
            newFromDate.setHours(0);
            newFromDate.setMinutes(0);
            newFromDate.setSeconds(0);
            exchangeRatesCtrl.calculateCriteria.exchangeDate = newFromDate;
            ExchangeRatesModel.calculateExchangeRate().then(function(calculateExchangeRateResult) {
                exchangeRatesCtrl.calculateExchangeRateResult = calculateExchangeRateResult;
                exchangeRatesCtrl.calculateExchangeRateResult.amount =
                    accounting.formatNumber(exchangeRatesCtrl.calculateExchangeRateResult.amount, CONSTANTS.numberFractionExchangeRateResult, CONSTANTS.thousandsSeparator, CONSTANTS.decimalSeparator);
                exchangeRatesCtrl.calculateExchangeRateResult.amountEUR =
                    accounting.formatNumber(exchangeRatesCtrl.calculateExchangeRateResult.amountEUR, CONSTANTS.numberFractionExchangeRateResult, CONSTANTS.thousandsSeparator, CONSTANTS.decimalSeparator);
                exchangeRatesCtrl.calculating = false;
            }, function(error){
                exchangeRatesCtrl.calculateErrorCode = error.data.code;
                exchangeRatesCtrl.calculateErrorParams = error.data.params;
                exchangeRatesCtrl.calculating = false;
            });
        };

        exchangeRatesCtrl.selectCalculateTab = function() {
            exchangeRatesCtrl.activeTabIndex = exchangeRatesCtrl.calculateTabIndex;
        };

        // export excel
        exchangeRatesCtrl.exportExcel = function() {
        	
        	if (!exchangeRatesCtrl.validateSearchForm()){
        		
                return;
            }

          	$rootScope.$broadcast('startSpinningExport');
          	ExchangeRatesModel.queryMonetaryExchangePeriodWithRateDirection().then(function(searchExchangeRatesResult) {

            	var reportDate = $filter('date')(new Date(), CONSTANTS.dateTimeFormat);
          		exchangeRatesCtrl.searchExchangeRatesExcelResult = searchExchangeRatesResult;
            	document.getElementById('reportDateExtr').innerHTML = reportDate;
            	
            	setTimeout(function(){

                	var title = $filter('translate')('i8n.qry.exchangerates.report.title');
                	var ws = {
                		'!cols': [{
                			wpx: 90
                		}, {
                			wpx: 120
                		}, {
                			wpx: 400
                		}, {
                			wpx: 150
                		}, {
                			wpx: 330
                		}, {
                			wpx: 330
                		}, {
                			wpx: 330
                		}]
                	};

                    if (CONSTANTS.menu.exchangeRates.simpleView){
                        ws = {
                            '!cols': [{
                                wpx: 120
                            }, {
                                wpx: 400
                            }, {
                                wpx: 150
                            }, {
                                wpx: 330
                            }]
                        };
                    }
                	CommonHelper.printExcel("exportExcelTable", title, ws).then(() => {
                        $rootScope.$broadcast('stopSpinningExport');
                    }, () => {
                        $rootScope.$broadcast('stopSpinningExport');
                    });
            	}, 1000);

            }, function(error){
                
            	// show errors here
            	exchangeRatesCtrl.searchErrorCode = error.data.code;
                exchangeRatesCtrl.searchErrorParams = error.data.params;
                exchangeRatesCtrl.searching = false;
              	$rootScope.$broadcast('stopSpinningExport');
            });
        };
        
        // print pdf
        exchangeRatesCtrl.print = function(options) {
        	
        	if (!exchangeRatesCtrl.validateSearchForm()){
        	    $scope.$apply();
        		
                return;
            }

          	$rootScope.$broadcast('startSpinningPrint');
        	ExchangeRatesModel.queryMonetaryExchangePeriodWithRateDirection().then(function(searchExchangeRatesResult) {
            	
        		exchangeRatesCtrl.searchExchangeRatesAllResult = searchExchangeRatesResult;
            	setTimeout(function(){

                    var doc = [];
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                    CommonHelper.printPlainDocument({
                        contents: doc,
                        logo: options.logo,
                        flag: exchangeRatesCtrl.flagImg,
                        eu: exchangeRatesCtrl.euImg,
                        validDate: $filter('date')(exchangeRatesCtrl.searchCriteria.fromDate, CONSTANTS.dateFormat),
                        title: $filter('translate')('i8n.qry.exchangerates.report.title')
                    }, 'l').then(() => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    }, (error) => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    });
                }, 1000);


            }, function (error) {
            	
            	exchangeRatesCtrl.searchErrorCode = error.data.code;
                exchangeRatesCtrl.searchErrorParams = error.data.params;
                exchangeRatesCtrl.searching = false;
              	$rootScope.$broadcast('stopSpinningPrint');
            });
        };

    	$scope.$on('printDocument', function(event, data) {

            CommonHelper.loadImage("img/flags/EU.png", 21, 14, function(options) {

                exchangeRatesCtrl.euImg = options.logo;
            }, true);
    		
    		var url = "img/flags/" + exchangeRatesCtrl.installationCountry + ".png";
    		CommonHelper.loadImage(url, 21, 14, function(options) {
    			
    			exchangeRatesCtrl.flagImg = options.logo;
        		CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, exchangeRatesCtrl.print, true);
    		}, true);
        });

    	$scope.$on('exportDocument', function(event, data) {
    		
    		exchangeRatesCtrl.exportExcel();
        });

        $rootScope.$on('$translateChangeSuccess', function () {

            //This is just a workaround to force the page to re-render the pagination items with translated texts
            exchangeRatesCtrl.itemsPerPage = 99999999;
            $timeout(function(){
                exchangeRatesCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            }, 100);
        });

        /**
         * 1.3. Query exchange rate - Search result:
         The url syntax:
         {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/duty/exchangerates?mu={MonetaryUnit}&ds={DateStart}&de={DateEnd}&l={Language}

         Example:
         http://www.testenv.se/arctictariff-public-web/#!/taric/duty/exchangerates?mu=AUD&ds=2015-01-01&de=2015-12-31&l=en
         */
        exchangeRatesCtrl.updateBrowserURL = function(){
            if (!CONSTANTS.enableBookmark){
                return;
            }

            //Only support bookmark when user enters at least one search criterion
            if (CommonHelper.removeSpaceCharacters(exchangeRatesCtrl.searchCriteria.monetaryUnit) === "" &&
                    !CommonHelper.getBookmarkDateString(exchangeRatesCtrl.searchCriteria.fromDate) &&
                    !CommonHelper.getBookmarkDateString(exchangeRatesCtrl.searchCriteria.toDate)){
                $location.search({}).replace();
                return;
            }
            $location.search({
                mu:  CommonHelper.removeSpaceCharacters(exchangeRatesCtrl.searchCriteria.monetaryUnit),
                ds: CommonHelper.getBookmarkDateString(exchangeRatesCtrl.searchCriteria.fromDate),
                de: CommonHelper.getBookmarkDateString(exchangeRatesCtrl.searchCriteria.toDate),
                l : $translate.use()
            }).replace();
        };
    });



// WEBPACK FOOTER //
// ./app/taric/duties/exchangerates/er-exchangerates.js